import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { loadResx, createTranslator } from '../../shared/helpers/resourceLoader';
import { useLocalization } from '../../context/LocalizationContext';
import { useSelectedDealership } from "../../hooks/useLocalStorage";
import getUserRoleFromJWT from '../../shared/helpers/getUserRoleFromJWT';

const NavButtons = () => {
  const { t: localization } = useLocalization();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const [selectedDealershipId] = useSelectedDealership();
 
  useEffect(() => {
    if (localStorage.getItem("accessToken")) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(true);
    }
  }, []);
  const userRole = getUserRoleFromJWT();
  const isServiceDeskWithoutDealer = userRole === '2' && !selectedDealershipId;
  const isActive = (path) => location.pathname === path;
 const getButtonClass = (path) => {
    let className = `btn btn-nav me-1 ${isActive(path) ? "active" : ""}`;
    if (isServiceDeskWithoutDealer) {
      className += " disabled";
    }
    return className;
  };

  
  const handleNavigation = (path) => {
    if (!isServiceDeskWithoutDealer) {
      navigate(path);
    }
  };

  const buttonStyle = isServiceDeskWithoutDealer ? 
    { cursor: 'not-allowed', opacity: 0.6 } : 
    {};

  if (!isLoggedIn) return null;

  return (
    <div className="nav-buttons bg-nav d-flex align-items-center navbar-buttons">
      {userRole === '1' && (
        <>
          <button
            className={`btn btn-nav me-1 ${isActive("/admin-dashboard") ? "active" : ""}`}
            onClick={() => navigate("/admin-dashboard")}
          >
            {localization('home')}
          </button>
          <button
            className={`btn btn-nav me-1 ${isActive("/repair-orders") ? "active" : ""}`}
            onClick={() => navigate("/repair-orders")}
          >
            {localization('service_orders')}
          </button>
          <button
            className={`btn btn-nav me-1 ${isActive("/customer") ? "active" : ""}`}
            onClick={() => navigate("/customer")}
          >
            {localization('customer')}
          </button>
        </>
      )}
       {userRole === '2' && (
        <>
          <button
            className={getButtonClass("/service-desk-dashboard")}
            onClick={() => handleNavigation("/service-desk-dashboard")}
            style={buttonStyle}
          >
            {localization('home')}
          </button>
          <button
            className={getButtonClass("/repair-orders")}
            onClick={() => handleNavigation("/repair-orders")}
            style={buttonStyle}
          >
            {localization('service_orders')}
          </button>
          <button
            className={getButtonClass("/customer")}
            onClick={() => handleNavigation("/customer")}
            style={buttonStyle}
          >
            {localization('customer')}
          </button>
        </>
      )}
    </div>
  );
};

export default NavButtons;